<!-- my-loader.component.html -->
<div class="progress-loader" [hidden]="!loading">  
  <div class="loading-spinner">
    <!-- <img src="/assets/icons/blue-loading-trans.svg"/>
      <span class="loading-message">Please wait...</span> -->
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
  </div>
</div>